<template lang="pug">

  .pie-chart-wrapper(ref='container')
    .inside-text
      slot

    div(style="position: relative; height: 100%; width: 100%;")
      canvas(ref="canvas", style="height: 100%; width: 100%;")

</template>

<script>
import Chart from 'chart.js'

export default {
  // DOCUMENTATION: https://www.chartjs.org/docs/latest/charts/doughnut.html
  props: {
    type: {'default': 'pie'}, // pie or doughnut
    data: {required: true},
    options: {'default': () => ({})}
  },
  data () {
    return {
      chart: null
    }
  },
  methods: {
    onClick (mouseEvent, chart) {
      try {
        const labelClicked = this.data.labelsData[chart[0]._index]
        this.$emit('click', {labelClicked, labelIndex: chart[0]._index})
      } catch (e) {}
    },
    renderCanvas (canvas, onClick) {
      this.chart = new Chart(canvas, {
        type: this.type,
        data: this.data,
        maintainAspectRatio: false,
        options: {
          cutoutPercentage: 65,
          legend: {
            display: false
          },
          animationSteps: 100,
          animationEasing: 'easeOutBounce',
          onClick,
          ...this.options
        }
      })
    }
  },
  mounted () {
    this.renderCanvas(this.$refs.canvas, this.onClick)
  }
}
</script>

<style scoped>
.pie-chart-wrapper {
  position: relative;
  align-items: center;
  justify-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  height: 100%;
}
.inside-text {
  position: absolute;
}
</style>
